// extracted by mini-css-extract-plugin
module.exports = {"BottomNavContainer":"BottomNav_BottomNavContainer__2x5Nh","BottomNav":"BottomNav_BottomNav__qBZb0","BottomItem":"BottomNav_BottomItem__1Nbas"};